import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';

function Badge(props) {
    const tabSelected = useSelector(state => state.data.tabSelected);
    const clickedBadgeParams = window.location.search.includes("cl=1") ?
        window.location.search : window.location.search + "&cl=1";

    const isBadgeEarned = badge => {
        if (badge && badge.badge_extra_data && badge.badge_extra_data.unearned && badge.badge_extra_data.unearned === "1") {
            return false;
        }

        return badge && badge.state && badge.state === "EARNED";
    };

    const isChallengeBadge = badge => {
        if (badge && badge.badge_extra_data && badge.badge_extra_data.challenge_id && badge.badge_extra_data.challenge_id !== "") {
            console.log(badge);
            return true;
        }

        return false;
    };

    let progessBarPct = 0;
    let progressBarEarned = 0;

    if (props.badge.streak) {
        progessBarPct = props.badge.streak.earned_count >= props.badge.streak.streak_count ? 100 :
            (props.badge.streak.earned_count / props.badge.streak.streak_count) * 100;
        progressBarEarned = props.badge.streak.earned_count >= props.badge.streak.streak_count ?
            props.badge.streak.streak_count : props.badge.streak.earned_count;
    }

    return (
        <div id={props.badge.id} key={props.badge.id} className={`badge ${props.badge.streak ? 'streak' : ''}`}>
            {
                tabSelected === "badges" && isChallengeBadge(props.badge) &&
                    <Link to={{ pathname: `/challenges/${props.badge.badge_extra_data.challenge_id}`, search: clickedBadgeParams }} title={props.badge.title} style={{}}>
                        {props.badge.streak && props.badge.streak.badge_count > 1 &&
                            <div className="count">
                                {`${props.badge.streak.badge_count}x`}
                            </div>
                        }
                        <img alt="Future badge" src={props.badge.image_url} style={{ opacity: props.badge.is_locked ? 0.4 : 1 }} />
                        <p>{props.badge.title && props.badge.title.length < 36 ? props.badge.title : `${props.badge.title.slice(0, 35)}...`}</p>
                    </Link>
            }
            {
                tabSelected === "badges" && !isChallengeBadge(props.badge) &&
                    <Link to={{ pathname: `/badges/${props.badge.id}`, search: clickedBadgeParams }} title={props.badge.title} style={{}}>
                        {props.badge.streak && props.badge.streak.badge_count > 1 &&
                            <div className="count">
                                {`${props.badge.streak.badge_count}x`}
                            </div>
                        }
                        <img alt="Future badge" src={props.badge.image_url} style={{ opacity: isBadgeEarned(props.badge) ? 1 : 0.4 }} />
                        <p>{props.badge.title && props.badge.title.length < 36 ? props.badge.title : `${props.badge.title.slice(0, 35)}...`}</p>
                    </Link>
            }
            {
                tabSelected === "play" &&
                    <Link to={{ pathname: `/play/${props.badge.id}`, search: clickedBadgeParams }} title={props.badge.title} style={{}}>
                        {props.badge.streak && props.badge.streak.badge_count > 1 &&
                            <div className="count">
                                {`${props.badge.streak.badge_count}x`}
                            </div>
                        }
                        <img alt="Future badge" src={props.badge.image} style={{ opacity: props.badge.is_locked ? 0.4 : 1 }} />
                        <p>{props.badge.title && props.badge.title.length < 36 ? props.badge.title : `${props.badge.title.slice(0, 35)}...`}</p>
                    </Link>
            }
            {
                tabSelected !== "badges" && tabSelected === "play" &&
                    <div onClick={() => { props.onClick() }}>
                        {props.badge.streak && props.badge.streak.badge_count > 1 &&
                            <div className="count">
                                {`${props.badge.streak.badge_count}x`}
                            </div>
                        }
                        <img alt="Future badge" src={props.badge.image} style={{ opacity: props.badge.is_locked ? 0.4 : 1 }} />
                        <p>{props.badge.title && props.badge.title.length < 36 ? props.badge.title : `${props.badge.title.slice(0, 35)}...`}</p>
                    </div>
            }
            {props.badge.streak && props.badge.streak.earned_count > 0 && !props.badge.streak.hide_progress ?
                <div className="streak-badge-progress">
                    {props.badge.streak.streak_count < 4 ?
                        <>
                            {props.badge.streak.streak_count >= 1 &&
                                <div className={`dot ${props.badge.streak.earned_count >= 1 ? 'unlocked' : ''}`}>1</div>
                            }
                            {props.badge.streak.streak_count >= 2 && <>
                                <div className={`dot-connect ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}></div>
                                <div className={`dot ${props.badge.streak.earned_count >= 2 ? 'unlocked' : ''}`}>2</div>
                            </>
                            }
                            {props.badge.streak.streak_count === 3 && <>
                                <div className={`dot-connect ${props.badge.streak.earned_count >= 3 ? 'unlocked' : ''}`}></div>
                                <div className={`dot ${props.badge.streak.earned_count >= 3 ? 'unlocked' : ''}`}>3</div>
                            </>
                            }
                        </>
                        :
                        <>
                            <div className="progress-bar">
                                <div className="inner" style={{ width: `${progessBarPct}%` }}></div>
                            </div>
                            <div className="progress-text">{`${progressBarEarned}/${props.badge.streak.streak_count}`}</div>
                        </>
                    }
                </div>
                :
                null
            }
        </div>
    );
}

export default Badge;
